import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/auth'

import { Loader } from 'lucide-react'
import appStore from 'src/assets/product-config/app-store.png'
import background from 'src/assets/product-config/background-signin.png'
import android from 'src/assets/product-config/google-play.png'
import { messageError, messageSuccess } from 'src/components/Message'
import { useClient } from '../../hooks/client'
import { parseError } from '../../services/api'
import { service } from '../../services/vf'
import { Button } from '../createAccountForm/styles'
import { FormInput } from '../newCreateAccountWallet/components'

interface IFormInput {
  email?: string
}

export const Forgot: React.FC = () => {
  const { client } = useClient()
  const [loading, setLoading] = useState(false)
  const navigation = useNavigate()
  const { account } = useAuth()

  const [email, setEmail] = useState('')

  const {
    handleSubmit,
    control,
    watch,
    setValue,
    // formState: { errors },
  } = useForm()

  const watchFields = watch()

  const handleResetPassword = async () => {
    if (!email) {
      messageError('Informe o seu e-mail')
      return
    }

    const isValid = /^[a-z0-9.]+@[a-z0-9]+\.[a-z]+(\.[a-z]+)?$/i.test(email)

    if (!isValid) {
      messageError('Informe um e-mail válido')
      return
    }

    try {
      setLoading(true)

      await service.post('accounts/reset-password', {
        email: email,
      })

      setValue('email', '')

      messageSuccess(
        'Foi enviado as instruções de recuperarção de senha para o seu e-mail.'
      )
    } catch (err) {
      const error = parseError(err) || 'Erro ao recuperar a senha.'

      messageError(error.message)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (account) {
      navigation('/')
    }
  })

  const navigate = useNavigate()

  return (
    <div
      style={{
        backgroundImage: `url(${background})
`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
      }}
      className="w-full flex-col h-screen flex justify-center items-center gap-20"
    >
      <div className="flex flex-col absolute bottom-10 left-10">
        <span className="text-white text-xl font-bold">Baixe o nosso app,</span>
        <span className="text-white text-xl">
          disponível nas principais lojas
        </span>
        <div className="flex gap-2 mt-2">
          <img
            alt=""
            src={android}
            className="w-[150px] object-contain cursor-pointer"
          />
          <img
            alt=""
            src={appStore}
            className="w-[150px] object-contain cursor-pointer"
          />
        </div>
      </div>
      <div className="bg-black mr-10 self-end bg-opacity-40 rounded-3xl backdrop-filter backdrop-blur-md border border-gray-600 p-12 max-w-[50%] flex flex-col justify-center items-center">
        <div className="w-full h-full">
          <div className="w-full flex items-start gap-10">
            <p className="font-medium text-white text-xl full-hd:text-2xl 3xl-hd:text-3xl qhd:text-3xl studio-laptop:text-4xl qhd-plus:text-5xl 4k:text-6xl 5k:text-6xl leading-7 mb-[4%]">
              Recuperação de senha
            </p>
          </div>

          <p className="text-white text-sm font-light mt-3 mb-4">
            Digite seu email para que possamos enviar um link para recuperar sua
            senha.
          </p>
          <FormInput
            onChangeText={setEmail}
            value={email}
            placeholder="Email"
          />
          <Button
            onClick={handleResetPassword}
            disabled={loading}
            className="bg-zinc-900"
          >
            {loading ? (
              <Loader size={20} color="#aaa" className="animate-spin" />
            ) : (
              'Enviar'
            )}
          </Button>
        </div>
      </div>
    </div>
  )
}
